import { dataShare } from 'dls-icons-data'
import { createIcon } from '../common'

const IconShare = /*#__PURE__*/createIcon(dataShare)
export default IconShare
